module.exports = __webpack_public_path__ + "img/loader.694af80f.gif";